module.exports = __webpack_public_path__ + "static/img/animation.be789ab4.gif";